import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgTravellerSelected = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#travellerSelected_svg__a)"
        d="M17.26 12a5.26 5.26 0 1 0 0 10.519 5.26 5.26 0 0 0 0-10.519"
      />
      <path
        fill="#fff"
        d="m19.777 15.084-3.175 3.174-1.86-1.86a.554.554 0 1 0-.785.784l2.253 2.253a.553.553 0 0 0 .783 0l3.567-3.567a.555.555 0 0 0-.783-.784"
      />
      <path
        fill="#000"
        d="M13.25 4a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M12 7.75c.922 0 1.689-.001 2.295.08.627.085 1.194.27 1.65.726s.64 1.021.725 1.65c.026.193.04.403.053.63a6.6 6.6 0 0 0-1.487.331 8 8 0 0 0-.052-.762c-.062-.461-.17-.658-.3-.789-.13-.13-.328-.238-.79-.3-.482-.065-1.13-.066-2.094-.066s-1.612.001-2.095.066c-.461.062-.658.17-.789.3-.13.13-.238.328-.3.79-.065.482-.066 1.13-.066 2.094V14c0 .492.002.786.03.997a.7.7 0 0 0 .042.178l.001.002h.002l.011.006c.022.009.07.024.167.037.21.028.505.03.997.03a.75.75 0 0 1 .75.75v4c0 .492.002.786.03.997a.7.7 0 0 0 .037.167l.005.01.001.003h.003l.01.006c.022.009.07.024.167.037.21.028.505.03.997.03l.042-.001a6.6 6.6 0 0 0 1.38 1.416 3 3 0 0 1-.225.042c-.334.045-.747.043-1.197.043s-.863.002-1.197-.043c-.356-.048-.731-.16-1.04-.47s-.422-.684-.47-1.04c-.045-.334-.043-.747-.043-1.197v-3.26a5 5 0 0 1-.447-.033c-.356-.048-.731-.16-1.04-.47s-.422-.684-.47-1.04c-.045-.334-.043-.747-.043-1.197v-1.5c0-.922-.001-1.689.08-2.295.085-.628.27-1.194.726-1.65s1.021-.64 1.65-.725c.605-.081 1.372-.08 2.294-.08"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id="travellerSelected_svg__a"
          x1={13.54}
          x2={20.978}
          y1={13.54}
          y2={20.978}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#61d18d" />
          <stop offset={1} stopColor="#4ea974" />
        </linearGradient>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgTravellerSelected);
export default Memo;
